



import {Component, Vue} from 'vue-property-decorator';
import LoginForm from "@/components/Molecules/LoginForm/LoginForm.vue";
import {CHECKBOX_STATUS, COOKIES} from "@/constants";
import {ServiceFactory} from "@/services/service-factory";
import {LoginFormType, LoginModel} from "@/share";
import {LoginFormDto} from "@/share/dto/login-form.dto";

const AuthService = ServiceFactory.get('auth');

@Component({
  components: {
    LoginForm
  }
})
export default class Login extends Vue {
  private isLoading = false
  private error = ''

  private async login(formData: LoginFormType) {
    const {email, password, rememberMe} = formData;
    const data: LoginFormDto = new LoginFormDto({
      email: email || '',
      password: password || '',
      rememberMe: rememberMe || CHECKBOX_STATUS.UN_ACCEPTED
    })
    this.error = ''
    this.isLoading = true
    let response = await AuthService.login(data).catch(() => new LoginModel({}));
    this.isLoading = false
    if (response.hasError) return this.error = response.message

    const {accessToken, expiresIn} = response

    if (accessToken) this.$cookies.set(COOKIES.accessToken, accessToken, expiresIn * 60)

    return this.$router.push({name: 'routes.home'})
  }
}
